import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import API from "../../../services/api";

import ProfileHeader from "../../../components/delivery/Profile/ProfileHeader/ProfileHeader";
import PersonalInfo from "../../../components/delivery/Profile/PersonalInfo/PersonalInfo";
import VehicleInfo from "../../../components/delivery/Profile/VehicleInfo/VehicleInfo";
import Documents from "../../../components/delivery/Profile/Documents/Documents";
import BankInfo from "../../../components/delivery/Profile/BankInfo/BankInfo";
import ProfileActions from "../../../components/delivery/Profile/ProfileActions/ProfileActions";

import "./DeliveryProfile.css";

function DeliveryProfile() {

    const navigate = useNavigate();

    const [partner, setPartner] = useState(null);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        fetchProfile();

    }, []);

    const fetchProfile = async () => {

        try {

            const response = await API.get("/delivery/profile");

            setPartner(response.data.deliveryPartner);

        }

        catch (error) {

            console.log(error);

            if (error.response?.status === 401) {

                navigate("/login");

            }

        }

        finally {

            setLoading(false);

        }

    };

    if (loading) {

        return (

            <div className="delivery-profile-loading">

                Loading Profile...

            </div>

        );

    }

    if (!partner) {

        return (

            <div className="delivery-profile-loading">

                Unable to load profile.

            </div>

        );

    }

    const profile = {

    profileImage: partner.profile?.photo
        ? `https://homefoods-backend-production.up.railway.app${partner.profile.photo}`
        : "/default-avatar.png",
        name: partner.userId?.name,

        email: partner.userId?.email,

        phone: partner.userId?.phone,

        rating: partner.statistics?.rating || 5,

        online: partner.work?.online,

        dateOfBirth: partner.profile?.dob,

        bloodGroup: partner.profile?.bloodGroup,

        address: {

            city: partner.address?.city,

            houseNumber: partner.address?.houseNumber,

            street: partner.address?.street,

            area: partner.address?.area,

            landmark: partner.address?.landmark,

            state: partner.address?.state,

            pincode: partner.address?.pincode

        },

        vehicle: {

            type: partner.vehicle?.vehicleType,

            number: partner.vehicle?.vehicleNumber,

            licenseNumber:
                partner.documents?.drivingLicense,

            insuranceVerified:
                partner.documents?.insuranceVerified

        },

        documents: {

            drivingLicense:
                partner.documents?.drivingLicense,

            drivingLicenseVerified:
                partner.documents?.drivingLicenseVerified,

            rcBook:
                partner.documents?.rcBook,

            rcBookVerified:
                partner.documents?.rcBookVerified,

            insurance:
                partner.documents?.insurance,

            insuranceVerified:
                partner.documents?.insuranceVerified,

            aadhaar:
                partner.documents?.aadhaar,

            aadhaarVerified:
                partner.documents?.aadhaarVerified

        },

        bank: partner.bank,

        earnings: partner.earnings,

        statistics: partner.statistics

    };

    return (

        <div className="delivery-profile-page">

            <ProfileHeader

                profile={profile}

            />

            <PersonalInfo

                profile={profile}

            />

            <VehicleInfo

                profile={profile}

            />

            <Documents

                profile={profile}

            />

            <BankInfo

                profile={profile}

            />

            <ProfileActions />

        </div>

    );

}

export default DeliveryProfile;